module.exports = __webpack_public_path__ + "static/media/notCome-receipt.1890e27f.svg";